<template>
  <router-link
    :to="`/dashboard/tests/${type}/${data.id}`"
    class="crop-bar-item"
  >
    <div ref="wrapper" class="wrapper --selector-overlay-pointer" :class="{'select-item' : $route.params.test == data.id && $route.path.includes(`/dashboard/tests/${type}/${data.id}/report`)}">
      <div class="title">
        {{ data.name }}
      </div>
      <div class="type">
        {{ $ml.get(`field`) }}:
        <template v-if="field">{{ field.name }}</template>
        <template v-else>-</template>

      </div>
      <div class="date">
        <!-- {{ data.date }} -->
        <!-- {{ new Date(data.created_at) | dateFormat('DD.MM.YYYY') }} -->
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: {},
  },
  methods: {
    onClick(e) {

    }
  },
  created() {
    this.field = this.$store.getters['farms/getFieldById'](this.data.fieldId);
  },
  computed: {
    ...mapGetters({
      filters: 'tests/sidebar/filters',
    }),
    type() {
      const type = this.filters.type;

      if(type == 'water-anal') {
        return 'water';
      }
      else if(type == 'soil-anal') {
        return 'soil';
      }
      else if(type == 'tissue-anal') {
        return 'tissue';
      }
      else if(type == 'media-anal') {
        return 'media';
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.crop-bar-item {
  display: flex;
  flex-direction: column;
  padding: 5px 0;

  border-top: 1px solid rgba(76, 80, 86, 0.10);

  .wrapper {
    padding: 8px 20px;
    z-index: 1;
    position: relative;
  }

  .title {
    color: #333333;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 5px;
    padding-right: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    transition: color 0.5s ease;
  }

  .type {
    color: #aaa;
    font-size: 10px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    font-weight: bold;

    transition: color 0.5s ease;
  }

  .date {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    font-size: 16px;
    color: #4C5056;
    transition: color 0.5s ease;
  }

  &.router-link-active {
    .title {
      color: #fff;
    }

    .type {
      color: #fff;
    }

    .date {
      color: #fff;
    }
  }
  .select-item{
    background: $mainGreen;
    box-shadow: 0px 2px 12px rbga(73, 125, 56, 0.5);
    border-radius: 5px;
  }
}

</style>
